import React, { useState } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
// import { PedidoContext } from '~/context/PedidoContext';
import { ModalVisualizar } from '~/components/Modal/VisualizarPedido';
import ReactGA from 'react-ga4';
import { TrStyled } from './styles';

export function LancamentosData(props) {
	const { user } = useSelector((state) => state.auth);

	const { lancamentos, toggleVisualizar, setToggleVisualizar, setAtualizaNF } = props;

	const [numPedido, setNumPedido] = useState('');
	const [idPedido, setIdPedido] = useState('');
	const [statusPedido, setStatusPedido] = useState('');
	const [statusNotas, setStatusNotas] = useState('');

	function renderColor(statusGeral, statusNota) {
		if (statusGeral === 'reprovado') {
			return color.red;
		}
		if (statusGeral === 'pendente') {
			return color.yellow;
		}
		switch (statusNota) {
			case 'Concluído':
				return color.green;
			case 'NF Pendente':
				return color.orange;
			case 'NF Enviada':
				return color.orange;
			case 'Pendente':
				return color.yellow;
			case 'Reprovado':
				return color.red;
			case 'pendentesalvar':
				return color.yello
			default:
				return 'Null';
		}
	}

	function verificaSeNotaFoiEnviada(nf) {
		if (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria') {
			if ((nf.length === 0 || nf.length > 0) && ((nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false) || (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false))) {
				return 'NF Pendente'
			}
			if (nf.length === 0) {
				return 'NF Pendente'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'NF Enviada'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'Concluído'
			}
		}
		if (user.dados.cargo.toLowerCase() === '') {
			handleClickViewNotaGA4()
			if ((nf.length === 0 || nf.length > 0) && ((nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false) || (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false))) {
				return 'Aguardando NF'
			}
			if (nf.length === 0) {
				return 'Aguardando NF'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'NF Recebida'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'Concluído'
			}
		}
		return 'pendente'
	}

	function handleClickViewNotaGA4() {
		ReactGA.event({
			category: "view_nota_click",
			action: "Revenda Visualiza Nota Fiscal",
			label: "Revenda Visualizando Nota Fiscal",
		});
	}

	return (
		<>
			<Table id="test-table-xls-button" responsive>
				<thead>
					<TrStyled>
						<th>Data</th>
						<th>Ref. Pedido</th>
						<th style={{ textAlign: 'left' }}>Distribuidor</th>
						<th style={{ textAlign: 'left', paddingLeft: 22 }}>
							{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && 'Revenda'}
							{user.dados.cargo.toLowerCase() === 'industria' && 'Distribuidores'}
						</th>
						<th>Valor</th>
						<th>Status</th>
					</TrStyled>
				</thead>
				<tbody>
					{lancamentos.map((item, index) => {
						return (
							<tr style={{ textAlign: 'center' }} key={`${item.autorizacao}-${index}`}>
								<td>
									{moment(item.data_pedido).format(
										'DD/MM/YYYY'
									)}
								</td>
								<td>{item.numero_pedido}</td>
								<td style={{ textAlign: 'left' }}>{item.nome}</td>
								<td style={{ textAlign: 'left' }}>{item.nome_destinatario}</td>
								<td>
									{symbolPriceFormatter(item.valor_pedido)}
								</td>
								<td>
									<button
										onClick={() => {
											setToggleVisualizar(
												!toggleVisualizar
											);
											setStatusNotas(verificaSeNotaFoiEnviada(item.nota_fiscal));
											setNumPedido(
												item.numero_pedido
											);
											setIdPedido(
												item.id.toString()
											);
											setStatusPedido(item.status.toLowerCase());
										}}
										style={{
											fontWeight: 'bold',
											border: 0,
											backgroundColor: 'white',
											color: renderColor(item.status.toLowerCase(), verificaSeNotaFoiEnviada(item.nota_fiscal)),
										}}
										type="button">
										{item.status.toLowerCase() === 'pendente' && 'Pendente'}
										{item.status.toLowerCase() === 'aprovado' && verificaSeNotaFoiEnviada(item.nota_fiscal)}
										{item.status.toLowerCase() === 'reprovado' && 'Reprovado'}
									</button>
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
			<ModalVisualizar
				statusPedido={statusPedido}
				statusNotas={statusNotas}
				idPedido={idPedido}
				setAtualizaNF={setAtualizaNF}
				user={user}
				numPedido={numPedido}
				tipo="solicitados"
				setToggle={setToggleVisualizar}
				toggle={toggleVisualizar}
			/>
		</>
	);
}
